/*** IMPORTS FROM imports-loader ***/
var define = false;

"use strict";
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import ScrollSpy from 'scrollspy';

let imagesLoaded = require('imagesloaded');
import Swiper from 'swiper';
import {Autoplay, Navigation, Pagination, EffectCoverflow, EffectCards, EffectFade} from 'swiper/modules';
import {random} from "gsap/gsap-core";

gsap.registerPlugin(ScrollTrigger);
document.addEventListener('DOMContentLoaded', function () {
    console.log('Init Scripts');
    // menu
    const menuBtn = document.getElementById('menu-burger');
    const b1 = document.querySelector('#menu-burger .b1');
    const b2 = document.querySelector('#menu-burger .b2');
    const overlay = document.getElementById('menu-overlay');
    const menuItems = gsap.utils.toArray('.menuItems a');
    const sMenuBtn = gsap.utils.toArray('.menuItems .has-submenu');
    let nav = document.querySelector(".navbar");
    let scrollTop = document.getElementById("scroll-top");
    let mm = gsap.matchMedia();
    let menuOpen = false;
    let navTl = null;
    const breakPoint = 1199;
    let isMobileG = false;
    mm.add({
        isDesktop: `(min-width: ${breakPoint}px)`,
        isMobile: `(max-width: ${breakPoint}px)`,
    }, (context) => {
        let {isDesktop, isMobile} = context.conditions;
        // hide overlay
        gsap.set(overlay, {
            marginTop: isMobile ? "-100vh" : 0
        })

        isMobileG = !!isMobile;
        // set menuItems
        gsap.set(menuItems, {
            opacity: isMobile ? 0 : 1
        })

        // overlay timeline
        navTl = gsap.timeline({
            defaults: {
                ease: 'power4.inOut',
                repeatRefresh: true,
            }
        });

        navTl
            .to(b1, {
                y: '-=5',
                duration: 0.2
            })
            .to(b2, {
                y: '+=5',
                duration: 0.2
            }, "-=0.2")
            .to(b1, {
                rotation: 45,
                transformOrigin: '50% 50%',
                duration: 0.3
            })
            .to(b2, {
                rotation: -45,
                transformOrigin: '50% 50%',
                duration: 0.3
            }, "-=0.3")
            .to(overlay, {
                marginTop: 0,
                duration: 0.5
            }, "-=0.5")
            .to(menuItems, {
                opacity: 1,
                stagger: 0.05,
                duration: 0.5
            }, "-=0.2")
        navTl.pause();
    })


    // scrollspy

    let navitems = document.querySelectorAll('.scrollspy-link');
    let one = document.querySelectorAll('.one-page');
    if (navitems.length > 1 && one.length > 0) {
        var spy = new ScrollSpy('#js-scrollspy', {
            nav: '.js-scrollspy-nav > a',
            className: 'active'
        });
        navitems.forEach(item => {
            item.addEventListener('click', (evt) => {
                console.log(menuOpen)
                if (menuOpen) {
                    // Delay setting the location some time
                    evt.preventDefault();
                    setTimeout(function () {
                        location.href = evt.target.href;
                    }, 1500);

                    navTl.reverse();
                    menuOpen = false;
                }
            });
        });

    }

    // toggle menu

    menuBtn.addEventListener('click', (evt) => {
        evt.preventDefault();
        if (!menuOpen) {
            navTl.play();
            menuOpen = true;
        } else {
            navTl.reverse();
            menuOpen = false;
        }
    })


    // navbar shrink
    window.addEventListener("scroll", function () {

        if (window.scrollY > 100) {
            scrollTop.classList.add('show')
            nav.classList.add("shrink");
        } else {
            scrollTop.classList.remove('show')
            nav.classList.remove("shrink");
        }
    });


    imagesLoaded(document.querySelector("main"), function (instance) {
        const stl = gsap.timeline();
        stl.to('.loader', {opacity: 0, duration: 0.3}, '-=0');
        stl.to('.navbar', {opacity: 1, duration: 0.6}, '-=0');
        stl.to('main', {opacity: 1, duration: 0.6}, '-=0.3');
        stl.to('footer', {opacity: 1, duration: 0.6}, '-=0');

        if (document.querySelector(".swiper-cards")) {

            gsap.utils.toArray(".swiper-cards").forEach(cards => {
                var swiper = new Swiper(cards, {
                    modules: [Autoplay, EffectCards],
                    effect: "cards",
                    grabCursor: true,
                    cardsEffect: {
                        perSlideOffset: 18,
                        perSlideRotate: 4,
                        rotate: true,
                        slideShadows: true,
                    }

                });
                swiper.slideTo(2)
            });

        }

        if (document.querySelector(".swiper-slider")) {
            // slider swiper
            let mm2 = gsap.matchMedia();

            const breakPoint2 = 600;
            mm.add({
                isDesktop2: `(min-width: ${breakPoint2}px)`,
                isMobile2: `(max-width: ${breakPoint2}px)`,
            }, (context) => {
                let {isDesktop2, isMobile2} = context.conditions;
                // hide overlay
                if(isMobile2){
                    const swiper1 = new Swiper('.swiper-slider .swiper1', {
                        modules: [Navigation, Pagination, Autoplay, EffectCoverflow],
                        navigation: {
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev',
                        },
                        // parameters
                        direction: 'horizontal',
                        centeredSlides: true,
                        slidesPerView: 1.3,
                        slideToClickedSlide: false,
                        /*   effect: 'coverflow',
                           coverflowEffect: {
                               depth: 10,
                               modifier: 1,
                               rotate: 10,
                               scale: 1,
                               slideShadows: false,
                               stretch: 0,
                           },*/

                        speed: 300,
                        loop: true,
                        autoplay: {
                            delay: 3100,
                            pauseOnMouseEnter: true,
                            disableOnInteraction: true,
                            reverseDirection: false,
                        },
                        spaceBetween: 30
                    });
                    //swiper1.slideTo(Math.round(random(5,12)))
                    const swiper2 = new Swiper('.swiper-slider .swiper2', {
                        modules: [Navigation, Pagination, Autoplay, EffectCoverflow],
                        navigation: {
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev',
                        },
                        // parameters
                        direction: 'horizontal',
                        centeredSlides: true,
                        slidesPerView: 1.3,
                        slideToClickedSlide: false,
                        /*effect: 'coverflow',
                        coverflowEffect: {
                            depth: 10,
                            modifier: 1,
                            rotate: 10,
                            scale: 1,
                            slideShadows: false,
                            stretch: 0,
                        },*/

                        speed: 300,
                        loop: true,
                        autoplay: {
                            delay: 3000,
                            pauseOnMouseEnter: true,
                            disableOnInteraction: true,
                            reverseDirection: true,
                        },
                        spaceBetween: 30
                    });
                    //swiper2.slideTo(Math.round(random(5,12)))
                }
                if(isDesktop2){
                    const swiper1 = new Swiper('.swiper-slider .swiper1', {
                        modules: [Navigation, Pagination, Autoplay, EffectCoverflow],
                        navigation: {
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev',
                        },
                        // parameters
                        direction: 'horizontal',
                        centeredSlides: true,
                        slidesPerView: "auto",
                        slideToClickedSlide: true,
                        /*   effect: 'coverflow',
                           coverflowEffect: {
                               depth: 10,
                               modifier: 1,
                               rotate: 10,
                               scale: 1,
                               slideShadows: false,
                               stretch: 0,
                           },*/
                        speed: 300,
                        loop: true,
                        autoplay: {
                            delay: 3100,
                            pauseOnMouseEnter: true,
                            disableOnInteraction: false,
                        },
                        spaceBetween: 30
                    });
                    swiper1.slideTo(Math.round(random(5,12)))
                    const swiper2 = new Swiper('.swiper-slider .swiper2', {
                        modules: [Navigation, Pagination, Autoplay, EffectCoverflow],
                        navigation: {
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev',
                        },
                        // parameters
                        direction: 'horizontal',
                        centeredSlides: true,
                        slidesPerView: "auto",
                        slideToClickedSlide: true,
                        /*effect: 'coverflow',
                        coverflowEffect: {
                            depth: 10,
                            modifier: 1,
                            rotate: 10,
                            scale: 1,
                            slideShadows: false,
                            stretch: 0,
                        },*/
                        speed: 350,
                        loop: true,
                        autoplay: {
                            delay: 3000,
                            pauseOnMouseEnter: true,
                            disableOnInteraction: false,
                            reverseDirection: true,
                        },
                        spaceBetween: 30
                    });
                    swiper1.slideTo(Math.round(random(5,12)))
                }
            })

        }

        //hero swiper
        let swiperh = new Swiper(".hero-swiper", {
            modules: [Autoplay, EffectFade],
            slidesPerView: 1,
            spaceBetween: 0,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            loop: true,
            speed: 800,
            autoplay: {
                delay: 3000,
            }
        });


        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: ".hero",
                start: "top top",
                end: "bottom top",
                scrub: true
            }
        });

        gsap.utils.toArray(".parallax").forEach(layer => {
            const depth = layer.dataset.depth;
            const movement = -(layer.offsetHeight * depth)
            tl.to(layer, {y: movement, ease: "none"}, 0)
        });


    })

});


